import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import Header from "./header";
import Footer from "./footer";
import { stuacademicyearlist, teacherdashboardcount, teacherdetail } from "../service/dashboard";
import moment from "moment";
import { Card, Col, Row } from "react-bootstrap";

const TeacherProfile = () => {
    const { id } = useParams();
    const [student, setStudent] = useState(null);
    const [activeTab, setActiveTab] = useState("profile");
    const [path, setPath] = useState("");
    const [adetail, setADetail] = useState([]);
    const [attdet, setAttdet] = useState([]);
    const [periods, setPeriod] = useState([]);
    const [ayear, setAYear] = useState("");
    const [ylist, setYList] = useState([]);
    useEffect(() => {

        const temp1 = new FormData();
        temp1.append("academy_id", localStorage.getItem("academy"));

        teacherdetail(id).then((res1) => {
            if (res1.status === true) {
                setPath(res1.data.path);
                setStudent(res1.data.details);
                setADetail(res1.data.attendance);
                const adata = res1.data.attendance.filter((item) => item.attendance.length > 0);
                setAttdet(adata);

                stuacademicyearlist(temp1).then((res) => {
                    if (res.status === true) {
                        const sorted = [...res.data].sort((a, b) => Number(b.id) - Number(a.id));
                        setYList(sorted);
                        if (sorted.length > 0) {
                            listall(sorted[0].id, res1.data.details.teacher_id);
                        }
                    }
                });
            }
        });
    }, [id]);
    const days = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];

    function listall(lyear, tid) {
        setAYear(lyear);
        setPeriod([]);
        const temp = new FormData();
        temp.append("user_id", tid || student.teacher_id);
        temp.append("year", lyear);
        temp.append("academy_id", localStorage.getItem("academy"));
        teacherdashboardcount(temp).then((res) => {
            if (res.status === true) {
                const periodMap = {};

                res.data.timetable.forEach(entry => {
                    const key = `${entry.period}_${entry.from_time}`;

                    if (!periodMap[key]) {
                        periodMap[key] = {
                            period: entry.period,
                            slot_name: entry.slot_name,
                            from_time: entry.from_time,
                            to_time: entry.to_time,
                            is_break: entry.is_break,
                            class_name: entry.class_name,
                            section_name: entry.section_name,
                            schedule: {
                                Monday: null,
                                Tuesday: null,
                                Wednesday: null,
                                Thursday: null,
                                Friday: null,
                                Saturday: null,
                            },
                        };
                    }

                    periodMap[key].schedule[entry.day] = {
                        subject_name: entry.subject_name,
                        teacher_name: entry.teacher_name,
                        teacher_photo: entry.teacher_photo,
                    };
                });

                let arr = Object.values(periodMap).sort((a, b) => a.period - b.period);
                setPeriod(arr);
            }
        })

    }

    function errorphoto(ev) {
        ev.target.src = require("../assets/images/teacher.jpg");
        ev.target.onerror = null;
    }
    return (
        <div id="mainpage">
            <div className="maincontent">
                <Header />
                <div className="moreheading">
                    <Row className="row-sm">

                        <Col xs={6} className="text-left align-self-end">
                            <h4 className="morehead-text">Teacher Profile</h4>
                        </Col>

                        <Col xs={6} className="text-right align-self-end">
                            <Link to={"/teacherlist"} className="btn-outline-success red-btn btn-sm">
                                <i className="fa-solid fa-hand-point-left"></i> Go Back
                            </Link>
                        </Col>

                    </Row>
                </div>
                {/* Student Card */}
                {student &&
                    <div className="container mt-3">
                        <div className="card text-center p-3 shadow-sm">
                            <img
                                src={path + student.photo}
                                onError={errorphoto}
                                alt="student"
                                className="rounded-circle mx-auto"
                                style={{ width: "90px", height: "90px" }}
                            />

                            <h5 className="mt-2">{student.teacher_name} ( {student.teacher_code} )</h5>

                            <p className="text-muted">
                                {student.class_name} - {student.section_name}
                            </p>
                            <p className="text-muted">
                                {student.gender}
                            </p>
                        </div>
                        <div className="tabs mt-3">
                            {["profile", "attendance", "timetable"].map((tab) => (
                                <button
                                    key={tab}
                                    className={`tab-btn ${activeTab === tab ? "active" : ""}`}
                                    onClick={() => setActiveTab(tab)}
                                >
                                    {tab.toUpperCase()}
                                </button>
                            ))}
                        </div>


                        {activeTab === "profile" && (
                            <>
                                <div className="card mt-3 shadow-sm">
                                    <div className="card-header custom-header">
                                        PERSONAL DETAIL
                                    </div>

                                    <div className="card-body">
                                        <div className="detail-grid">
                                            <div><b>Name</b><span>{student.teacher_name}</span></div>
                                            <div><b>DOB</b><span>{student ? moment(student.date_of_birth).format("DD-MM-YYYY") : ""}</span></div>
                                            <div><b>Blood Group</b><span>{student.bloodgroup || "-"}</span></div>
                                            <div><b>Email</b><span>{student.email_id || "-"}</span></div>
                                            <div><b>Phone</b><span>{student.phone}</span></div>


                                            <div><b>Father Name</b><span>{student.father_name || "-"}</span></div>
                                            <div><b>Mother Name</b><span>{student.mother_name || "-"}</span></div>
                                            <div><b>Marital Status</b><span>{student.marital_status || "-"}</span></div>
                                            <div><b>Address</b><span>{student.address1 || "-"}</span></div>
                                            <div><b>Pin Code</b><span>{student.pincode || "-"}</span></div>
                                        </div>
                                    </div>
                                </div>

                                <div className="card mt-3 shadow-sm">
                                    <div className="card-header custom-header">
                                        ACADEMY DETAIL
                                    </div>

                                    <div className="card-body">
                                        <div className="detail-grid">
                                            <div><b>Unique No</b><span>{student.username}</span></div>
                                            <div><b>Staff Code</b><span>{student.teacher_code}</span></div>
                                            <div><b>Qualification</b><span>{student.qual_name}</span></div>
                                            <div><b>Department</b><span>{student.Teacher}</span></div>
                                            <div><b>Designation</b><span> {student.desi_name}</span></div>
                                            <div><b>Pre Institute</b><span>{student.ins_name || "-"}</span></div>

                                            <div><b>Reporting To</b><span>{student.report_name || "-"}</span></div>
                                            <div><b>Appointment</b><span>{student.appoint_name || "-"}</span></div>
                                            <div><b>Shift</b><span>{student.shift_name || "-"}</span></div>
                                            <div><b>Bank Name</b><span>{student.bank_name || "-"}</span></div>
                                            <div><b>Account No</b><span>{student.bank_accno || "-"}</span></div>
                                            <div><b>Admission Date</b><span> {student ? moment(student.adm_date).format("DD-MM-YYYY") : ""}</span></div>

                                        </div>
                                    </div>
                                </div>


                            </>
                        )}


                        {activeTab === "attendance" && (
                            <div className="card mt-3 p-3 shadow-sm">
                                {adetail && adetail.length > 0 &&
                                    adetail.map((item, index) => (
                                        <div key={index} className="row row-cards mt-1">
                                            {item.attendance.length > 0 &&
                                                <>
                                                    <h5>{item.year}</h5>
                                                    <div className="row">
                                                        <div className="col-sm-12 col-md-6 col-lg-6 col-xl-3">

                                                            <div className="card bg-custom">
                                                                <div className="card-body text-center feature">
                                                                    <p className="card-text mt-2">
                                                                        <strong>Total Days</strong>
                                                                    </p>
                                                                    <p className="h3 text-center text-info">{item.total_days}</p>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div className="col-sm-12 col-md-6 col-lg-6 col-xl-3">
                                                            <div className="card bg-custom">
                                                                <div className="card-body text-center feature">
                                                                    <p className="card-text mt-2">
                                                                        <strong>Total Present</strong>
                                                                    </p>
                                                                    <p className="h3 text-center text-success">{item.total_present_days}</p>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div className="col-sm-12 col-md-6 col-lg-6 col-xl-3">
                                                            <div className="card bg-custom">
                                                                <div className="card-body text-center feature">
                                                                    <p className="card-text mt-2">
                                                                        <strong>Total Absent</strong>
                                                                    </p>
                                                                    <p className="h3 text-center text-danger">{item.absent_days}</p>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div className="col-sm-12 col-md-6 col-lg-6 col-xl-3">
                                                            <div className="card bg-custom">
                                                                <div className="card-body text-center feature">
                                                                    <p className="card-text mt-2">
                                                                        <strong>Half day</strong>
                                                                    </p>
                                                                    <p className="h3 text-center text-warning">{item.half_day_present}</p>
                                                                </div>
                                                            </div>
                                                        </div>


                                                    </div>
                                                </>
                                            }

                                        </div>
                                    ))
                                }
                                {attdet && attdet.length == 0 &&
                                    <div className="d-md-flex ms-auto mb-2">
                                        <label className="my-auto pt-2 exam-title"><strong>No Attendance Found</strong></label>
                                    </div>
                                }
                            </div>
                        )}
                        {activeTab === "timetable" && (
                            <div className="card mt-3 p-3 shadow-sm">
                                <div className="mobile-timetable">
                                    {periods.length === 0 && (
                                        <p className="text-center">No timetable found</p>
                                    )}
                                    <div className="col-sm-12 col-md-12 col-lg-6 col-xl-4">
                                        <div className="mb-3">
                                            <label className="form-label">
                                                Academic Year<span className="text-danger"> *</span>
                                            </label>
                                            <select
                                                className="default-select  form-control wide"
                                                value={ayear}

                                                onChange={(e) =>
                                                    listall(e.target.value)
                                                }
                                            >
                                                <option value="" disabled>
                                                    Select Academic Year
                                                </option>
                                                {ylist.map((item, i) => {
                                                    return (
                                                        <option value={item.id} key={i}>
                                                            {item.aca_year}
                                                        </option>
                                                    );
                                                })}
                                            </select>
                                        </div>
                                    </div>
                                    {periods.map((period, index) => (
                                        <div key={index} className="tt-card">

                                            <div className="tt-header">
                                                <div>
                                                    <strong>{period.slot_name}</strong>
                                                    <div className="tt-time">
                                                        {period.from_time} - {period.to_time}
                                                    </div>
                                                </div>
                                            </div>

                                            {period.is_break === "Yes" ? (
                                                <div className="tt-break">{period.slot_name}</div>
                                            ) : (
                                                <div className="tt-body">
                                                    {days.map((day, i) => (
                                                        <div key={i} className="tt-row">
                                                            <span className="day">{day}</span>

                                                            {period.schedule[day] ? (
                                                                <div className="subject">
                                                                    <div className="sub-name">
                                                                        {period.schedule[day].subject_name} ({period.class_name} - {period.section_name})
                                                                    </div>
                                                                    <div className="teacher">
                                                                        {period.schedule[day].teacher_name}
                                                                    </div>
                                                                </div>
                                                            ) : (
                                                                <span className="empty">-</span>
                                                            )}
                                                        </div>
                                                    ))}
                                                </div>
                                            )}
                                        </div>
                                    ))}
                                </div>
                            </div>
                        )}


                    </div>
                }
            </div>

            <Footer />
        </div>
    );
};

export default TeacherProfile;